<!-- Modal -->
<div class="modal fade" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="modalLabel">{{header}}</div>
        <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>An installed backflow prevention device will allow water to enter your vehicle through the filling point on your vehicle, but
          will prevent the water from flowing back into the reticulated water supply network.
        </p>
        <p>
          As per Australian Standard <b>AS3500</b>, your vehicles must have one of the following backflow prevention devices
          installed:
        </p>
        <ul>
          <li>A registered Air Gap, or</li>
          <li>A Reduced Pressure Zone Device (RPZD)</li>
        </ul>
        <p>
          Each vehicle and backflow prevention device is required to undergo inspection by an accredited backflow plumber to
          ensure compliance with the conditions of your permit. Once inspected you or your plumber must provide South
          East Water with a copy of the report
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="proceedYes()">Close</button>
      </div>
    </div>
  </div>
</div>